import { A11y, Autoplay, EffectFade, Parallax } from 'swiper/modules';
import { SWIPER_EFFECT, SWIPER_PARALLAX } from '../../../../constants/globalConstants.js';
import { applySliderVariationStrategy } from './applySliderVariationStrategy.js';
export var carouselOptionsHandler = function carouselOptionsHandler(carouselOptions, timePerSlide) {
  var modules = [A11y, Autoplay];
  var options = {
    spaceBetween: 0,
    slidesPerView: 1,
    rewind: true,
    autoplay: {
      enabled: true,
      delay: 8000,
      disableOnInteraction: false,
      pauseOnMouseEnter: true
    }
  };
  var config = applySliderVariationStrategy(carouselOptions, timePerSlide);
  if (SWIPER_EFFECT.FADE.NAME === config.effect) {
    modules.push(EffectFade);
    options.effect = SWIPER_EFFECT.FADE.LIBRARY_NAME;
  }
  if (SWIPER_EFFECT.SLIDE.NAME === config.effect) {
    options.effect = SWIPER_EFFECT.SLIDE.LIBRARY_NAME;
  }
  if (SWIPER_PARALLAX.ENABLED === config.parallaxType) {
    modules.push(Parallax);
    options.parallax = true;
    options.speed = 1200;
  }
  if (SWIPER_PARALLAX.ENABLED_SINGLE_IMAGE === config.parallaxType) {
    modules.push(Parallax);
    options.parallax = true;
  }
  if (config.autoplay === false) {
    options.autoplay.enabled = false;
  }
  if (config.timePerSlide) {
    options.autoplay.delay = config.timePerSlide;
  }
  return {
    config: config,
    options: options,
    modules: modules
  };
};